import React, {useCallback, useContext, useState} from "react";
import {Select} from "antd";
import MapPropsContext from "../MapPropsContext";
import {Title} from "./Common";

const { Option } = Select;

const WidgetSelectBand = ({}) => {

  const {
    widgetState,
    onChangeWidgetState,
    setGeojsonExtraParams,
  } = useContext(MapPropsContext);
  const {frqField1, frqField2} = widgetState;

  const fieldName = "frq_gubun_field";
  const fieldValue = widgetState[fieldName];

  const fieldName2 = "hz_gubun_field";
  const fieldValue2 = widgetState[fieldName2];

  const [state, setState] = useState({
    indeterminate: "",
  });

  const onFrqGubunChange = useCallback((frqGubun) => {
    setState({
      indeterminate: frqGubun,
    });
    onChangeWidgetState({
      target: {
        name: fieldName,
        value: frqGubun,
      }}
    );
  }, [options]);

  // 바꿔야함.
  const onHzGubunChange = useCallback((frq) => {
    setState({
      indeterminate: frq,
    });
    onChangeWidgetState({
      target: {
        name: fieldName2,
        value: frq,
      }}
    );
  }, [options_hz]);

  const options =
  [
    { value: ['FRQ', 'FRQ1', 'FRQ2', 'FRQ3', 'FRQ4', 'FRQ5', 'FRQ6'], name: "전체",  },
    { value: "FRQ1", name: "3.0 ~ 3.2GHz",  },
    { value: "FRQ2", name: "3.7 ~ 4.2GHz" },
    { value: "FRQ3", name: "4.4 ~ 4.5GHz" },
    { value: "FRQ4", name: "4.5 ~ 5.0GHz" },
    { value: "FRQ5", name: "7.725 ~ 8.5GHz" },
    { value: "FRQ6", name: "10.0 Ghz 이상" },
  ];

  const options_hz =
  [
    { value: 1, name: "Hz" },
    { value: 1000, name: "kHz" },
    { value: 1000000, name: "MHz" },
    { value: 1000000000, name: "GHz" },
  ];

  return (
    <div>
      <Title>주파수대역</Title>
      <br/>
      <Select
        defaultValue={"전체"}
        onChange={onFrqGubunChange}
        fieldName={"frq_gubun_field"}
        style={{width: '26%',  float: 'left', textAlign: 'center'}}
        placeholder={"주파수 대역을 선택해주세요."}
      >
        {options
          .map(({name, value}) =>
            <Select.Option key={name} value={value}>
              {name}
            </Select.Option>
          )}
      </Select>


      {/* <span><h3>주파수시작끝</h3></span> */}
      <span className={"ant-input-affix-wrapper"} style={{ width: '230px', marginLeft : '8px'}}>
        <div className={["uid-field", "ant-input"].join(" ")}>
          <input type="text"
            name="frqField1"
            maxLength={11}
            size={11}
            value={frqField1}
            onChange={onChangeWidgetState}
            //onPaste={onPaste}
            style={{ border: 0, width: '6.5em'}} />
              ~
          <input type="text"
            name="frqField2"
            maxLength={11}
            size={11}
            value={frqField2}
            onChange={onChangeWidgetState}
            //onPaste={onPaste}
            style={{ border: 0, width: '6.5em'}} />
        </div>
      </span>

      <Select
        defaultValue={"Hz"}
        onChange={onHzGubunChange}
        fieldName2={"hz_gubun_field"}
        style={{width: '26%',  float: 'right', textAlign: 'center'}}
        placeholder={"주파수 대역을 선택해주세요."}
      >
        {options_hz
          .map(({name, value}) =>
            <Select.Option key={name} value={value}>
              {name}
            </Select.Option>
          )}
      </Select>

    </div>
  );
};



export default WidgetSelectBand;
